import { computed, defineComponent } from "vue";
import Section from 'components/section'
import { HeaderMd } from 'components/headers/md'
import HeaderSm from 'components/headers/sm'
import Button from 'components/button'
import WithBubbletip from 'components/with-bubbletip'
import { useCurrentUser } from '@/modules/user/hooks/useCurrentUser'
import { EAuthenticationMethod } from 'findef'
import { SettingsCard } from '@/modules/settings/components/settings-card'
import { pushChangePasswordModal } from "@/modules/settings/modals/changePassword";

export default defineComponent(() => {
  definePageMeta({
    layout: 'settings',
    name: 'Security & Password'
  })
   const user = useCurrentUser()
   const isBankId = computed(() => {
      return user.user.value.authenticationMethod === EAuthenticationMethod.BANKID})
   const isGoogle = computed(() => {
      return user.user.value.authenticationMethod === EAuthenticationMethod.GOOGLE})
   const handleChangePassword = () => {
      void pushChangePasswordModal();
    }
   const handleActivate2FA = () => {
      alert('Activate 2FA clicked!')
    }

  return () => {
    return <div class="w-full h-full flex flex-col gap-4">
      <HeaderSm
        title="Security"
        subtitle="These settings are critical to your account. Please be careful when changing them!"
      />

      {/*
          Change Password
        */}
      <SettingsCard loading={false}>
        <Section>
          <HeaderMd
            title="Change Password"
            subtitle="Change the password for your account."
          />
          <div class="mt-4">
            {(isBankId.value || isGoogle.value) ? (
              <WithBubbletip
                tooltip={{
                  text: isBankId.value
                    ? 'Password changes are not available for BankID accounts.'
                    : 'Password changes are not available for Google accounts.',
                  variant: 'white'
                }}
              >
                <Button
                  disabled
                  variant="primary"
                  onClick={handleChangePassword}
                  class="min-w-[150px] text-center"
                >
                  Change Password
                </Button>
              </WithBubbletip>
            ) : (
              <Button
                variant="primary"
                onClick={handleChangePassword}
                class="min-w-[150px] text-center"
              >
                Change Password
              </Button>
            )}
          </div>
        </Section>
      </SettingsCard>


      {/*
          Two-Factor Authorization (2FA) BankID Account
        */}
      <SettingsCard loading={false}>
        <Section>
          <HeaderMd
            title={
              <>
                Two‑Factor Authorization (2FA)
                {isBankId.value && (
                  <span class="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-xs text-xs font-semibold bg-primary-100 text-primary-500">
                    BankID Account
                  </span>
                )}
              </>
            }
            subtitle="Activate multi factor authorization for your account. Coming soon! Stay tuned for updates."
          />
          <div class="mt-4">
            <Button
              disabled
              // disabled={isBankId.value}
              variant="primary"
              onClick={() => {
                if (!isBankId.value) handleActivate2FA()
              }}
              class="min-w-[162px] text-center"
            >
              {isBankId.value ? 'Activated' : 'Activate 2FA'}
            </Button>
          </div>
        </Section>
      </SettingsCard>

      {/*
          Delete Account
        */}
      <SettingsCard loading={false}>
        <Section>
          <HeaderMd
            title="Danger Zone"
            subtitle={
              <>
                Send a request to <span class="font-bold text-red-500">team@findex.se</span> if you would
                want to delete your account and your information
              </>
            }
          />
          {/* <div class="mt-4">
                <Button
                  disabled
                  variant="error100"
                  class="min-w-[162px] text-center">
                  Delete Account
                </Button>
              </div> */}
        </Section>
      </SettingsCard>
    </div>
  }
})
